enum NotificationType {
  Failed = 'failed',
  Success = 'success',
  Info = 'info'
}

export enum NotificationDuration {
  Infinite = -1,
  Short = 3000,
  Medium = 5000,
  Long = 8000
}

export default NotificationType
